module.exports = "/images/Roofing---Hero.jpg";